import config from 'config/config';
import { api } from 'redux/api/index.api';
import checkOrSetSlash from 'utils/checkOrSetSlash';
import { getBusinessOrganizationVersion } from 'utils/constants';

const getRootProjectPath = () =>
  `${checkOrSetSlash(
    config.apiHostGatewayGlobal,
    'apiHostGatewayGlobal',
  )}api/${getBusinessOrganizationVersion()}/organizations`;

export const workspacesApi = api.injectEndpoints({
  endpoints: builder => ({
    fetchWorkspace: builder.query({
      query: ({ organizationId, workspaceId }) => ({
        url: `${getRootProjectPath()}/${organizationId}/workspaces/${workspaceId}`,
        method: 'GET',
      }),
    }),
    fetchWorkspaces: builder.query({
      query: ({ organizationId, search_term, parent_id }) => ({
        url: `${getRootProjectPath()}/${organizationId}/workspaces/user_workspaces`,
        method: 'POST',
        body: {
          parent_id,
          search_term,
        },
      }),
      providesTags: ['WorkspacesList'],
      keepUnusedDataFor: 0,
      serializeQueryArgs: ({ queryArgs }) => {
        const { organizationId, parent_id } = queryArgs;
        return `${organizationId}-${parent_id || 'root'}`;
      },
      transformResponse: response => ({
        workspaces: response.workspaces.map(workspace => ({
          ...workspace,
          path: workspace.parent_id ? [workspace.parent_id, workspace.id] : [workspace.id],
        })),
        total: response.count,
      }),
      merge: (currentCache, newItems, { arg }) => {
        const { parent_id } = arg;
        if (!parent_id) {
          return newItems;
        }
        return {
          ...currentCache,
          workspaces: [...(currentCache?.workspaces || []), ...(newItems?.workspaces || [])],
          total: (currentCache?.total || 0) + (newItems?.total || 0),
        };
      },
    }),
    fetchWorkspaceChildren: builder.query({
      query: ({ organizationId, workspaceId }) => ({
        url: `${getRootProjectPath()}/${organizationId}/workspaces/${workspaceId}/children/ids`,
        method: 'GET',
      }),
    }),
    deleteWorkspace: builder.mutation({
      query: ({ organizationId, workspaceId }) => ({
        url: `${getRootProjectPath()}/${organizationId}/workspaces/${workspaceId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['WorkspacesList'],
    }),
  }),
  overrideExisting: 'throw',
});

export const {
  useFetchWorkspaceQuery,
  useLazyFetchWorkspaceQuery,
  useLazyFetchWorkspacesQuery,
  useDeleteWorkspaceMutation,
} = api;
